export const ServiceStatusKey = 'service-status';
export const ServiceStatusCodeKey = 'service-status-code';
export const NextServiceStatusKey = 'next-service-status';
export const AvailableStatusKey = 'available-service-status';
export const CancelReOpenStatusKey = 'cancel-reopen-service-status';